(function($) {
    var message = null;
    var okCallback = null;
    var cancelCallback = null;
    var openCallback = null;
    var className = null;
    
    $.extend({
        showMessageDialog : function(options) {
            var dialogID = '#messageDialog';
            var title = '';
            var dialogWidth = 400;
            var draggable = false;
            var resizable = false;
            var position = {my: 'center', at: 'center', of: window};
            
            var buttons = {
                "OK" : {
                    text : okButtonText,
                    click : function() {
                        $(this).dialog('close');
                        
                        if (!!okCallback && typeof okCallback === 'function') {
                            okCallback.call(this);
                        }
                    }
                }
            };

            if (options) {
                if (!!options.dialogID) {
                    dialogID = options.dialogID;
                }
                
                if (!!options.title) {
                    title = options.title;
                }
            
                if (!!options.message) {
                    message = options.message;
                    
                    // Array of messages?
                    if ($.isArray(message)) {
                    	message = message.join('<br/>');
                    }
                }
                
                if (!!options.width) {
                	dialogWidth = options.width;
                }
                
                if (!!options.draggable) {
                	draggable = options.draggable;
                }
                
                if (!!options.resizable) {
                	resizable = options.resizable;
                }
                
                if (!!options.openCallback) {
                    openCallback = options.openCallback;
                }
                
                if (!!options.okCallback) {
                	okCallback = options.okCallback;
                }
                
                if (!!options.cancelCallback) {
                    cancelCallback = options.cancelCallback;
                }
                
                if (!!options.className) {
                    className = options.className;
                }
                
                if (!!options.showCancel) {
                    buttons.CANCEL = {
                        text : cancelButtonText,
                        click : function() {
                            $(this).dialog('close');
                            
                            if (!!cancelCallback && typeof cancelCallback === 'function') {
                                cancelCallback.call(this);
                            }
                        }
                    }
                }
                
                if (!!options.position) {
                    position = options.position;
                }
            }
            
            var dialogClassContainer = 'cpwr-ui-dialog';
            
            if (!!className) {
                dialogClassContainer = dialogClassContainer + ' ' + className;
            }
            
            $(dialogID).dialog({
                title : title,
                width : dialogWidth,
                modal : true,
                draggable : draggable,
                resizable : resizable,
                classes: {'ui-dialog' : dialogClassContainer},
                buttons : buttons,
                open: function() {
                    $(this).html(message ? message : '');

                    $(dialogID + ' + .ui-dialog-buttonpane > .ui-dialog-buttonset > button')
                    	.removeClass("ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only");
                    
                    if (typeof openCallback === 'function') {
                        openCallback.call(this);
                    }

                    $(this).dialog('option', 'position', position);
                },
                close: function(event, ui) {
                    $(this).html('');
                }
            });
        }
    });
})(jQuery);